import ErrorBoundary from "components/utils/ErrorBoundary";
import bdaylytics from "components/utils/analytics/bdaylytics";
import { loadStorageState, saveStorageState } from "components/utils/app";
import { logInfo } from "components/utils/logger";
import { useApp, usePageVisibility } from "hooks/app";
import { useMember } from "hooks/member";
import LayoutPage from "pages/layout";
import PageNotFound from "pages/static/page-not-found";
import React, { Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import renderAccountRoutes from "routes/account";
import renderAuthRoutes from "routes/auth";
import renderBirthdayRequestRoutes from "routes/birthday-request";
import renderCardRoutes from "routes/card";
import renderCleanRoutes from "routes/clean";
import renderRemindersRoutes from "routes/reminders";
import renderStaticRoutes from "routes/static";
import { getVersion } from "services/app-service";

const BirthdayAlarmApp = () => {
  const location = useLocation();
  const isVisible = usePageVisibility();
  const { initialized } = useMember();
  const { serverVersion } = useApp();

  const retryReloadCount = loadStorageState("retryReloadCount") || 0;

  useEffect(() => {
    checkAppVersion(serverVersion);
  }, []);

  useEffect(() => {
    if (isVisible) {
      getAppVersion();
    }
  }, [isVisible]);

  useEffect(() => {
    if (initialized) {
      // Send page view metric
      bdaylytics.page({ path: location.pathname, isRoot: true });
    }
  }, [location, initialized]);

  useEffect(() => {
    if (!(location.pathname === "/cards" || location.pathname.indexOf("/cards/") >= 0)) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  const getAppVersion = async () => {
    const { version } = await getVersion();
    checkAppVersion(version);
  };

  // App version checking
  const checkAppVersion = (versionToCheck) => {
    if (versionToCheck !== global.version && retryReloadCount < 3) {
      saveStorageState("retryReloadCount", retryReloadCount + 1);
      window.location.reload();
    } else {
      saveStorageState("retryReloadCount", 0);
    }
  };

  logInfo(`RENDER: Bday App`);

  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        <Routes>
          <Route element={<LayoutPage clean />}>{renderCleanRoutes()}</Route>
          <Route element={<LayoutPage />}>
            {renderStaticRoutes()}
            {renderAccountRoutes()}
            {renderAuthRoutes()}
            {renderRemindersRoutes()}
            {renderBirthdayRequestRoutes()}
            {renderCardRoutes()}
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
};

BirthdayAlarmApp.propTypes = {};

BirthdayAlarmApp.defaultProps = {};

//BirthdayAlarmApp.whyDidYouRender = true;

export default BirthdayAlarmApp;
